export interface CouponDescriptionSections {
	descripcion?: string;
	descripcionCorta?: string;
	restricciones?: string;
	mensajeRechazo?: string;
}

const O = '(?:ó|&oacute;|&#243;|o)?';
const COLON = '\\s*(?:&nbsp;|\\s)*:';

const LABELS: Array<{ key: keyof CouponDescriptionSections; regex: RegExp }> = [
	{ key: 'descripcionCorta', regex: new RegExp(`descripci${O}n\\s+corta${COLON}`, 'i') },
	{ key: 'descripcion', regex: new RegExp(`descripci${O}n${COLON}`, 'i') },
	{ key: 'restricciones', regex: new RegExp(`re+stricci${O}ne?s${COLON}`, 'i') },
	{ key: 'mensajeRechazo', regex: new RegExp(`mensaje\\s+de\\s+re+chaz${O}${COLON}`, 'i') },
];

const clean = (raw: string): string | undefined =>
	raw
		.replace(/<\/?p[^>]*>/gi, ' ')
		.replace(/<br\s*\/?>/gi, ' ')
		.replace(/\s+/g, ' ')
		.trim() || undefined;

export const parseCouponDescription = (longDescription?: string): CouponDescriptionSections => {
	if (!longDescription) return {};

	const found = LABELS.map(({ key, regex }) => {
		const match = regex.exec(longDescription);
		return match ? { key, start: match.index, contentStart: match.index + match[0].length } : null;
	})
		.filter(
			(
				item
			): item is { key: keyof CouponDescriptionSections; start: number; contentStart: number } =>
				item !== null
		)
		.sort((a, b) => a.start - b.start);

	if (!found.length) return {};

	const sections: CouponDescriptionSections = {};
	found.forEach((label, index) => {
		const end = index + 1 < found.length ? found[index + 1].start : longDescription.length;
		sections[label.key] = clean(longDescription.slice(label.contentStart, end));
	});

	return sections;
};
